import { ethers } from 'ethers';

import { Erc20Controller } from '@bitcoin-portal/neko-web-sdk';

import { APPROVE_MAX_VALUE } from '@context/constants';

export const approveToken = async (
  tokenContract: Erc20Controller,
  amountDesired: ethers.BigNumber,
  allowance: ethers.BigNumber,
  routerAddress: string,
) => {
  if (amountDesired.lte(allowance)) return;
  const approveRes = await tokenContract.approveToken(
    routerAddress,
    APPROVE_MAX_VALUE,
  );
  if (approveRes.isFailure) throw new Error(approveRes.error);
  const tx = approveRes.getValue();
  await tx.wait();
};

export default approveToken;
